// src/components/OrganizationDropdown.tsx
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'; // Assicurati di avere react-bootstrap installato
import { useAuth } from '../../../../app/modules/auth/core/Auth';
import './OrganizationDropdown.css';

interface Organization {
  ID_Organizzazione: number;
  Nome: string;
  isActive: boolean;
  Codice_associazione: string;
}

const OrganizationDropdown: React.FC = () => {
  const { currentUser, setActiveOrganization } = useAuth(); // Assumi che tu abbia definito setActiveOrganization nel contesto di Auth
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null);

  // Se currentUser.user_organizzazione è l'array delle associazioni (con organizzazione e ruolo)
  useEffect(() => {
    if (currentUser && currentUser.user_organizzazione && currentUser.user_organizzazione.length > 0) {
      // Seleziona quella con la data più antica oppure la prima nell'array
      const defaultOrg = currentUser.user_organizzazione[0].organizzazione;
      console.log("vedimm", currentUser.user_organizzazione);
      setSelectedOrg(defaultOrg);
      if (setActiveOrganization) {
        setActiveOrganization(defaultOrg);
      }
    }
  }, [currentUser, setActiveOrganization]);

  const handleSelect = (org: Organization) => {
    setSelectedOrg(org);
    if (setActiveOrganization) {
      setActiveOrganization(org);
    }
  };

  if (!currentUser || !currentUser.user_organizzazione) {
    return null;
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant="secondary" id="organization-dropdown" style={{ width: '380px' }}>
       {selectedOrg
         ? `${selectedOrg.Nome} – ${selectedOrg.Codice_associazione}`
         : 'Seleziona Organizzazione'}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ width: '380px' }}>
        {currentUser.user_organizzazione.map((assoc: any, index: number) => (
          <Dropdown.Item key={index} onClick={() => handleSelect(assoc.organizzazione)}>
            {assoc.organizzazione.Nome} - {assoc.organizzazione.Codice_associazione}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { OrganizationDropdown };
